<style scoped>

</style>

<template>
  <div style="display: flex; justify-content: space-between; margin-top: 20px; gap: 10px;">
    <v-btn
      v-if="shouldShowSkipBtn"
      data-qa="dialog_resource_add__skip_btn"
      @click="onSkipSection"
    >
      {{ translate('ui_skip_btn') }}
    </v-btn>

    <v-btn
      v-if="shouldShowCancelBtn"
      data-qa="dialog_resource_add__cancel_btn"
      color="default"
      @click="onLocalCancel"
      style="align-self: start;"
    >
      {{ translate('ui_cancel_btn') }}
    </v-btn>

    <div style="margin-left: auto; display: flex; gap: 10px;">

      <v-btn
        data-testid="dialog_resource_add__save_and_add_btn"
        v-if="shouldShowSaveAndAddBtn"
        @click="onSaveAndAdd"
        :disabled="isSaveDisabled"
      >
        {{ translate('ui_save_and_add_btn') }}
      </v-btn>

      <v-btn
        data-testid="dialog_resource_add__save_btn"
        color="primary"
        @click="onLocalSave"
        :disabled="isSaveDisabled"
      >
        {{ translate('ui_save_btn') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import Mixin from '../../mixins/mixin';

export default {
  name: 'DialogToolbarBottom',
  mixins: [Mixin],
  props: [
    'section',
    'resource',
    'tab',
    'dialogResourceAddFinancingTabIndex',
    'isSaveDisabled',
    'onSave',
    'onCancel',
    'onChangeStepDialogFinancing',
    'shouldHideCancelBtnFromParent',
  ],
  computed: {
    shouldShowSaveAndAddBtn() {
      const noSaveAndAddBtnSectionIds = ['section_financing', 'section_currency', 'section_taxes', 'section_depreciation', 'section_inflation'];
      return !noSaveAndAddBtnSectionIds.includes(this.section.id) && this.section.isAddingResource;
    },
    shouldShowSkipBtn() {
      return false;
      // return this.section.canSkip && !this.section.isInitialized;
    },
    shouldShowCancelBtn() {
      const { isAddingResource } = this.section;
      const isEditingResource = this.resource && this.resource.isEdited;
      const isInitializedSection = this.section.id === 'section_taxes' || this.section.id === 'section_depreciation';
      return !this.shouldHideCancelBtnFromParent && (isEditingResource || (isAddingResource && this.section.isInitialized) || isInitializedSection);
    },
  },
  methods: {
    scrollBack() {
      const scrollY = this.$store.state.dialogScrollYPosition;
      if (scrollY) {
        window.scrollTo({
          top: scrollY,
          left: 0,
          behavior: 'smooth',
        });
        this.$store.commit('updateState', {
          path: 'dialogScrollYPosition',
          value: null,
        });
      }
    },
    onLocalCancel() {
      // this.section.isEditingSettings = false;
      this.section.isAddingResource = false;
      if (this.onCancel) {
        this.onCancel();
        this.scrollBack();
      }
    },
    onSkipSection() {
      // eslint-disable-next-line
      const sectionIndex = this.$store.state.activeTemplate.data.sections.findIndex((sectionInState) => sectionInState.id === this.section.id);
      this.$store.dispatch('updateState', {
        path: `activeTemplate.data.sections[${sectionIndex}].isEnabled`,
        value: false,
      });
      this.$store.dispatch('updateState', {
        path: `activeTemplate.data.sections[${sectionIndex}].isInitialized`,
        value: true,
      });
      // scroll to next section
      // this.revealNextSection();
    },
    onSaveAndAdd() {
      this.onSave(true);
    },
    onLocalSave() {
      if (typeof this.section.sectionResources === 'undefined') {
        this.saveSection(this.section);
      } else {
        this.onSave(false);
        this.scrollBack();
      }
    },
  },
};
</script>
